import { FC } from 'react';
import NextImage from 'src/shared-components/NextImage/NextImage';
import cn from 'classnames';
import {
  AccordionHeaderContent,
  AccordionItemContentType
} from 'src/api/types';

interface Props {
  header: AccordionHeaderContent;
  productsList: AccordionItemContentType[];
  active: boolean;
}

const arrowIcon = 'shared/arrow-grey.svg';
const AccordionDefaultHeader: FC<Props> = ({ header, active }) => {
  return (
    <div className="flex w-full justify-between items-center">
      <div className="flex flex-col items-start">
        <div className="text-[16px] text-left  text-mako uppercase">
          {header.useCustomWrapper
            ? header.useCustomWrapper(header.title)
            : header.title}
        </div>
      </div>
      <div className="flex items-center">
        <div className={cn(active ? '' : 'transform -rotate-180')}>
          <div className="flex items-center justify-center w-6 h-6 rounded-full bg-wildSand opacity-75">
            <NextImage alt="arrow" src={arrowIcon} height={12} width={12} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionDefaultHeader;
